<div class="menu">
  @for (item of menuStructure; track item) {
    @if (item.component === 'MenuItem') {
      <a
        appButton
        shape="round"
        name="{{ item.text | lowercase }}"
        location="website-header"
        color="simple-gray"
        weight="bold"
        [routerLink]="[item.link | storyblokLink]"
        [routerLinkActive]="'bc-simple-primary constant'"
        class="top-level-button"
      >
        <span>{{ item.text }}</span>
      </a>
    } @else {
      <app-context-menu
        [options]="{ width: '520px', noSpacing: true, openOnHover: true, bigBorderRadius: true }"
        position="screen-center"
        #menu
      >
        <button
          contextButton
          appButton
          shape="round"
          name="{{ item.text | lowercase }}"
          location="website-header"
          color="simple-gray"
          weight="bold"
          [routerLinkActive]="'bc-simple-primary constant'"
          [ngClass]="{ 'bc-simple-primary': isActive(item), constant: menu._isOpen() || isActive(item) }"
          class="top-level-button"
        >
          <span>{{ item.text }}</span>
          <app-svg src="/assets/icons/16/arrow-down.svg" size="-1"></app-svg>
        </button>
        <div contextContent class="dropdown-menu">
          @for (subItem of item.buttons; track subItem) {
            @if (subItem.link.linktype === 'story') {
              <a
                name="website-header: {{ subItem.text | lowercase }}"
                color="simple-gray"
                weight="bold"
                [routerLink]="[subItem.link | storyblokLink]"
                [routerLinkActive]="'active'"
              >
                <div class="icon-container">
                  <app-svg [src]="subItem.icon.filename | storyblokCdn"></app-svg>
                </div>
                <span>{{ subItem.text }}</span>
              </a>
            } @else {
              <a
                name="website-header: {{ subItem.text | lowercase }}"
                color="simple-gray"
                weight="bold"
                [href]="subItem.link.url"
                target="_blank"
              >
                <div class="icon-container">
                  <app-svg [src]="subItem.icon.filename | storyblokCdn"></app-svg>
                </div>
                <span>{{ subItem.text }}</span>
              </a>
            }
          }
        </div>
      </app-context-menu>
    }
  }
</div>
